import { Navigate, Outlet } from "react-router-dom";
import type { UserRole } from "@opus-dt/shared-types";
import { useAuthStore } from "@/stores/auth.store";

interface RequireRoleProps {
  // Nome `requiredRole` (não `role`) evita falso-positivo de jsx-a11y/aria-role.
  requiredRole: UserRole;
}

// Guard de rota por papel. `ProtectedLayout` garante usuário autenticado; este
// componente restringe rotas a um papel específico (ex.: tela única de CLPs a GESTOR).
// Acesso negado → redireciona ao Dashboard (a entrada de nav também é ocultada).
export function RequireRole({ requiredRole }: RequireRoleProps) {
  const user = useAuthStore((s) => s.user);
  if (!user || user.role !== requiredRole) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}
